import React from "react";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import HomeIcon from "@mui/icons-material/Home";
import KidoProject from '../../../../assets/images/logo.png';

const AccountDeletionInstructions: React.FC = () => {
  return (
    <div className="container">
      {/* Material-UI Breadcrumb Navigation */}
      <Breadcrumbs aria-label="breadcrumb" className="mb-4">
        <Link
          color="inherit"
          href="/"
          className="d-flex align-items-center"
          underline="hover"
        >
          Home
        </Link>
        <Typography color="text.primary">Data Deletion Instructions</Typography>
      </Breadcrumbs>

      <div className="card">
        <div className="card-body">
          <div className="content-area">
            <h3 className="mb-6 pt-cursor">
              Data Deletion Instructions
            </h3>

            <h5 className="mb-3">
              On the Android App – KidoProtect
              <a
                href="https://play.google.com/store/apps/details?id=com.kidoprotect.app&hl=en_IN"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary ms-2"
              >
                (https://play.google.com/store/apps/details?id=com.kidoprotect.app&hl=en_IN)
              </a>
            </h5>
            <p className="mb-3">To delete your account using the KidoProtect Android app, please follow the steps below:</p>
            <ol className="ps-4">
              <li className="mb-2">Open the left-side menu</li>
              <li className="mb-2">Navigate to Settings</li>
              <li className="mb-2">Tap on General Settings</li>
              <li className="mb-2">Select Account Settings</li>
              <li className="mb-6">Tap Delete My Account and follow the on-screen prompts to confirm your decision</li>
            </ol>
            <p className="mb-6 "><strong>Important: This action is permanent and cannot be undone. All your account data will be permanently deleted.</strong></p>

            <h5 className="mb-3">On the Web Portal – KidoProtect
              <a
                href="https://web.kidoprotect.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primary ms-2"
              >
                (https://web.kidoprotect.com)
              </a>
            </h5>

            <p className="mb-3">To delete your account through the KidoProtect web portal, please follow these steps:</p>
            <ol className="ps-4">
              <li className="mb-2">Open the left-side navigation bar</li>
              <li className="mb-2">Go to Settings</li>
              <li className="mb-2">Click on Account Settings</li>
              <li className="mb-6">Tap Delete My Account and follow the on-screen instructions to confirm</li>
            </ol>
            <p className="mb-6"><strong>Please Note: Once your account is deleted, all associated data will be permanently removed and cannot be recovered.</strong></p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AccountDeletionInstructions;